import { render, staticRenderFns } from "./EchartsList.vue?vue&type=template&id=2b37047c&scoped=true"
import script from "./EchartsList.vue?vue&type=script&lang=js"
export * from "./EchartsList.vue?vue&type=script&lang=js"
import style0 from "./EchartsList.vue?vue&type=style&index=0&id=2b37047c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b37047c",
  null
  
)

export default component.exports